<div class="container-fluid page" *ngIf="!edit">
  <div class="d-flex page__box p-3 mt-2">&nbsp; Fertilizer Application Reminders <div class="export_csv">
      <div class="add_button_text"><button class="add_button_new pull-right" (click)="formPage()" mat-raised-button
          color="primary">Add New Notification</button></div>&nbsp;&nbsp;<button class="clear_button_export"
        (click)="openDialogexport()" style="float: right;margin-top: -36px;" mat-raised-button
        color="primary">Export</button>
    </div>
  </div>
  <div class="page__content shadow p-3" style="margin-top: -3rem;">
    <div class="" *ngIf="selectedIndex === 1">
      <!--class="page__content-data" remove by shivam modi -->
      <div>
        <br />
        <div class="row" style="margin-top: -40px;">
          <div class="col-3 topData">
            <p>
              Reminder posted
            </p>
            <p style="font-size: 2rem;">{{getAverageData.totalReminder}}</p>
          </div>
          <div class="col-4 topData">
            <p>
              Reminder posted this month
            </p>
            <p style="font-size: 2rem;">{{getAverageData.monthlyReminder}}</p>
          </div>
          <div class="col-9 pull-right">

          </div>
        </div>

        <mat-card>
          <div class="example-header">
            <mat-form-field class="full-width-field" style="width: 50% !important;">
              <input matInput [(ngModel)]="searchData" (change)="changeFn($event)" placeholder="Search">
            </mat-form-field>&nbsp;&nbsp;

            <button type="submit" (click)="applyfilter(true)" class="btn btn-primary mat-primary search_bar">
              <mat-icon class="search_bar_icon">search</mat-icon>
            </button>
            <hr>
            <mat-form-field  (click)="suche()">
              <mat-select [formControl]="bankMultiCtrl" [(ngModel)]="statedata" ngDefaultControl  placeholder="States"
                [multiple]="true" #multiSelect noEntriesFoundLabel="'no matching country found'">
                <mat-option>
                  <ngx-mat-select-search id="search1" [showToggleAllCheckbox]="true" (ngModelChange)="filterMyOptions($event);notFound()"
                    [toggleAllCheckboxIndeterminate]="isIndeterminate" [toggleAllCheckboxChecked]="isChecked"
                    (toggleAll)="toggleSelectAll($event)" [formControl]="bankMultiFilterCtrl"></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let bank of filteredBanksMulti | async" [value]="bank">
                  {{bank.stateName}}
                </mat-option>
              </mat-select>
            </mat-form-field>&nbsp;
            <!-- <mat-form-field>
              <input matInput [(ngModel)]="statedatafilter" placeholder="State">
            </mat-form-field>&nbsp; -->

            <!-- <mat-form-field >
              <mat-label>State</mat-label>
              <mat-select formControlName="states" multiple>
                <mat-option *ngFor="let state of states" [value]="state">{{state}}</mat-option>
              </mat-select>
            </mat-form-field> -->

            <mat-form-field>
              <input matInput type="text" name="daterange" placeholder="Date Range" [min]="minDate" autocomplete="off"
                [max]="maxDate" [alwaysShowCalendars]="true" ngxDaterangepickerMd [(ngModel)]="sharedate"
                 [showCustomRangeLabel]="true" [ranges]="ranges"  [locale]="{applyLabel: 'ok', format: 'DD/MM/YYYY'}"
                (change)="onDateRangeChanged(sharedate)" />
            </mat-form-field>

            <button class="btn btn-primary mat-primary clear_button pull-right" style="margin-top: 12px;"
              (click)="clearFilter()">Clear Filter</button>
            <button type="submit" style="margin-top: 12px; margin-right: 10px;" (click)="applyfilter(true)"
              class="btn btn-primary mat-primary pull-right">Apply Filter </button>

            <mat-chip-list #chipList aria-label="Filter selection">
              <mat-chip *ngFor="let filter of matChipArray;let i=index" [selectable]="selectable"
                [removable]="removable" (removed)="remove(i,filter.tag)">
                {{filter.name}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>

            <div class="text_filter_data" *ngIf="exportcsvdata">
              <p *ngIf="this.length == 0"> There's no record found with the given criteria,
                please try again refining your search and filters </p>
            </div>

          </div>
        </mat-card>
        <!-- </mat-card> -->
        <div class="mat-elevation-z8 position-relative" style="margin-top: 15px;">
          <mat-table #table [dataSource]="dataSource" matSort>

            <!-- Name Column -->
            <ng-container matColumnDef="notification">
              <mat-header-cell mat-sort-header *matHeaderCellDef ><span>Notification</span> </mat-header-cell>
              <mat-cell *matCellDef="let userlist"><span style="width: 420px;">{{userlist.notification}}</span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="attachlink">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Attached Link </mat-header-cell>
              <mat-cell *matCellDef="let userlist">
                <span style="width:200px" *ngIf="userlist.attachlink != ''">
                  <a target="_blank" href="{{userlist.attachlink}}">
                    Available Link</a>
                </span>
                <span *ngIf="userlist.attachlink == '' ">
                  <p style="margin-top: 12px !important;">Unavailable</p>
                </span>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="states">
              <mat-header-cell mat-sort-header *matHeaderCellDef ><span style="margin-left: 50px;">States</span></mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{userlist.states}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="sentDate">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Sent Date </mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{formatDate(userlist.sentDate)}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="updatedBy">
              <mat-header-cell mat-sort-header *matHeaderCellDef> Updated By </mat-header-cell>
              <mat-cell *matCellDef="let userlist">{{userlist.updatedBy}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let userlist">
                <div>
                  <mat-icon class="colorchange" (click)="editNotification(userlist)">edit</mat-icon>&nbsp;&nbsp;&nbsp;
                  <mat-icon class="colorchange" (click)="openDialog(userlist.fertilizerReminderID)">delete</mat-icon>
                </div>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>
          <div>
            <mat-paginator [length]="length" [pageIndex]="pageIndex" (page)="getServerData($event)"
              [pageSizeOptions]="[10,20,50,100]" showFirstLastButtons aria-label="">
            </mat-paginator>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="container-fluid page" *ngIf="edit">
  <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
      (click)="listPage()">&nbsp;&nbsp;Edit Fertilizer Application Reminder</div>
  <div class="example-header" style="height: 556px;">
    <mat-card class="matCardForm">
      <mat-card-content class="pa-1">
        <form [formGroup]="form1" (ngSubmit)="onSubmit()">
          <div class="fulllwidth">

            <input type="hidden" formControlName="id">
            <mat-form-field>
              <textarea type="text" required formControlName="notification" style="height: 50px;" maxlength="300"
                rows="5" matInput placeholder="Type notification text here (300 characters maximum)"></textarea>
            </mat-form-field>

            <mat-form-field appearance="fill">
              <mat-label>Target users in these states* (minimum one)</mat-label>
              <mat-select formControlName="states" multiple required>
                <mat-option *ngFor="let state of statesList" [value]="state">{{state}}</mat-option>
              </mat-select>
            </mat-form-field>&nbsp;

            <mat-form-field>
              <input type="text" formControlName="attachlink" matInput placeholder="Attach Link">
            </mat-form-field>

            <!-- <mat-form-field>
              <input type="text" maxlength="100" rows="2" required formControlName="remark" matInput
                placeholder="Remark">
            </mat-form-field> -->

            <div class="row">
              <div class="col-md-8">
              </div>
              <div class="col-md-4">
                <button mat-button type="submit" [disable]="disable" style="color: white;" class="submitBtn">Send
                  Reminder</button>
              </div>
            </div>

          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
